import * as React from "react";
import { useNavigate } from "@opendash/router";
import { AppLayout } from "./AppLayout";
import { useTexts } from "../hooks/useTexts";
import {
  TabContainer,
  TabButton,
  ContentContainer,
  Card,
  SourcesSection,
} from "./common/StyledComponents";

export const WasserzaehlerRoute = React.memo(function WasserzaehlerRoute() {
  const navigate = useNavigate();
  const { t } = useTexts();

  const tabs = [
    {
      title: t("regenwasser.tab.grauwasser", "Regen- und Grauwasser"),
      path: "/wasserklaerer/regenwasser",
      isActive: false,
    },
    {
      title: t("regenwasser.tab.wasserzaehler", "Wasserzähler"),
      path: "/wasserklaerer/regenwasser/wasserzaehler",
      isActive: true,
    },
    {
      title: t("regenwasser.tab.leitungen", "Leitungen"),
      path: "/wasserklaerer/regenwasser/leitungen",
      isActive: false,
    },
  ];

  return (
    <AppLayout>
      <ContentContainer>
        <h1>{t("regenwasser.title", "Regen- und Grauwassernutzung")}</h1>

        <TabContainer>
          {tabs.map((tab, index) => (
            <TabButton
              key={index}
              isActive={tab.isActive}
              onClick={() => !tab.isActive && navigate(tab.path)}
            >
              {tab.title}
            </TabButton>
          ))}
        </TabContainer>

        <Card>
          <h2>{t("wasserzaehler.section1.title", "Wasserzähler")}</h2>
          <p>
            {t(
              "wasserzaehler.section1.text1",
              "Dieser Bereich wird demnächst mit Inhalten zu Wasserzählern gefüllt."
            )}
          </p>
        </Card>

        <SourcesSection>
          <h3>{t("wasserzaehler.literatur.title", "Literaturverzeichnis")}</h3>
          <ol>
            <li id="quelle-1">
              {t("wasserzaehler.literatur.ref1", "Quellen folgen.")}
            </li>
          </ol>
        </SourcesSection>
      </ContentContainer>
    </AppLayout>
  );
});
